import React from "react";
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';



const useStyles = makeStyles((theme) => ({
    upbtnon:{
        textTransform: 'initial',
        backgroundColor: 'rgb(1, 151, 1)',
        border: 'solid 1px rgb(1, 151, 1)',
        color: 'white',
        '&:hover':{
            backgroundColor: 'rgb(1, 151, 1)'
        },
        marginBottom: '3px',
        width: '80px'
    },
    upbtndown:{
        textTransform: 'initial',
        border: 'solid 1px rgb(1, 151, 1)',
        color: 'rgb(1, 151, 1)',
        marginBottom: '3px',
        width: '80px'
    },
    downbtnon:{
        textTransform: 'initial',
        backgroundColor: 'rgba(218, 32, 32, 0.884)',
        border: 'solid 1px rgba(218, 32, 32, 0.884)',
        color: 'white',
        '&:hover':{
            backgroundColor: 'rgba(218, 32, 32, 0.884)'
        },
        marginBottom: '3px',
        width: '80px'

    }, 
    downbtndown:{
        textTransform: 'initial',
        color: 'rgba(218, 32, 32, 0.884)',
        border: 'solid 1px rgba(218, 32, 32, 0.884)',
        marginBottom: '3px',
        width: '80px'

    },
}));

export default function UpDownHolder(props){
    const classes=useStyles();


    const changeVote = (direction, voted) =>{
        props.changeUpDownVote(props.username, props.commentId, direction,voted);
       
    }
    return (
        <div style={{textAlign: 'center'}}>
        <Button className={(props.updownvotes.upvotes.voted? classes.upbtnon : classes.upbtndown)} 
            size='small' style={{textTransform: 'initial', paddingTop: 2, paddingBottom: 2, minWidth: 0, marginLeft: 5}}
            onClick={()=>changeVote('up',props.updownvotes.upvotes.voted )}>
                Up {props.updownvotes.upvotes.count} 
        </Button>
        <Button className={(props.updownvotes.downvotes.voted? classes.downbtnon : classes.downbtndown)} 
            size='small' style={{textTransform: 'initial', paddingTop: 2, paddingBottom: 2, minWidth: 0, marginLeft: 5}}
            onClick={()=>changeVote('down',props.updownvotes.downvotes.voted)}>
                Down {props.updownvotes.downvotes.count} 
        </Button>
    </div>
    )

}
